import './App.css';
import { Routes,Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { cookies_string } from './config.js'
import { useEffect, useState } from 'react';

import App_ from './App_.js';
import App2_ from './App2_.js';
import Website from './screens2/website/Website.js';
import PublicPlatform from './screens/public/Router.js';

function App(props) {
  const [cookies, setCookie, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);

  // const [isLogin, setIsLogin] = useState(true)
  // useEffect(() => {
  //   const handleLogin = async () => {
  //     // const userName = await prompt('please input username')
  //     const password = await prompt('please input password')
  //     if( password === 'readbeyond2025' || false) setIsLogin(true)
  //     // setIsLogin(true)
  //   }
  //   if(!isLogin){
  //     handleLogin()
  //   }
  // },[]);


  // if(!isLogin){
  //   return <div>Access denied</div>
  // }

    
    return (
      <div className="root flex flex-col w-full h-full">
        <Routes>
            <Route path="/" element={<Website />}/>
            <Route path="/public/*" element={<PublicPlatform />}/>
            <Route path="/platform/*" element={<App_ />}/>
            <Route path="/platform2/*" element={<App2_ />}/>
            <Route path="*" element={<Website />}/>
        </Routes>
      </div>
    );


}

export default connect((store)=>{
  return{
    token:store.tokenReducer,
    control:store.controlReducer,
  }
})(App)